import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import { submitArchiveCalls, submitMarkCallsAsSeen } from '~/api/data/calls/mutations';
import { loadCall } from '~/api/data/calls/queries';
import { CallPage, CallsListPage } from '~/pages/calls/calls';

export const callLogRoute: RouteObject = {
  path: 'log',
  element: <CallsListPage />,
  children: [
    {
      path: 'archive',
      action: byMethod({
        POST: submitArchiveCalls
      })
    },
    {
      path: 'mark-seen',
      action: byMethod({
        POST: submitMarkCallsAsSeen
      })
    },
    {
      path: ':id',
      loader: merge({ call: loadCall }),
      element: <CallPage />
    }
  ]
};
